/** Display only: preserve the source period key and never round or rebucket values. */
export function claimsPeriodStartUtc(periodStart: string): string {
  const instant = new Date(periodStart);
  return Number.isFinite(instant.getTime())
    ? instant.toISOString().replace("T", " ").replace("Z", " UTC")
    : "Unavailable period start";
}

export function claimsPeriodAxisUtc(periodStart: string): string {
  const instant = new Date(periodStart);
  return Number.isFinite(instant.getTime()) ? instant.toISOString().slice(0, 10) : "";
}
